
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchList } from '@/api/scm/delivery';
import { Message } from 'element-ui';

const date = new Date();
const start = new Date(new Date(date.toLocaleDateString()).getTime()).getTime(); // 当天0点
const end = new Date(new Date(date.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime();

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {
            time: [start, end]
        }
    },
    actions: {
        async getList({ state, dispatch, commit }, payload) {
            await wait(dispatch, 'scm.delivery.list', async function () {
                const { searchForm } = state;


                const response = await fetchList({
                    startTime: searchForm.time && parseInt(searchForm.time[0] / 1000),
                    endTime: searchForm.time && parseInt(searchForm.time[1] / 1000)
                });

                if (response.data && response.data.length > 0) {
                    commit('save', {
                        list: response.data
                    })
                } else {
                    Message.error({ message: '暂无数据' })
                }
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/delivery/list.js